/* eslint-disable object-curly-newline */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  filter: PropTypes.string.isRequired,
  summary: PropTypes.number,
  title: PropTypes.string.isRequired,
  toFilter: PropTypes.func.isRequired,
};

const defaultProps = {
  summary: 0,
};

const CotizacionesFilterHeadComponent = (props) => {
  const { summary, title, filter, toFilter } = props;

  return (
    <div className="statistic" onClick={toFilter(filter)}>
      <h1>{summary}</h1>
      <h5>{title}</h5>
    </div>
  );
};

CotizacionesFilterHeadComponent.propTypes = propTypes;
CotizacionesFilterHeadComponent.defaultProps = defaultProps;

export default CotizacionesFilterHeadComponent;
